export enum TableNameKeys {
  DRIVER_VEHICLE_MATCH = "DriverVehicleMatch",
  PARCEL = "Parcel",
  DRIVER = "Driver",
  VEHICLE = "Vehicle",
  SCHEDULED_JOURNEY = "scheduledJourney",
  LEZ = "LEZ"
}
